class APIS {
	apis() {
		return {
			templateAnalytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/analytics'
			},
			pricingAnalytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/pricing-analytics'
			},
			conversationAnalytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/conversation-analytics'
			},
			messagingAnalytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messaging-analytics'
			},
			webhookFunnelAnalytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/webhook/reports/funnel-analytics'
			},
			webhookReportsAnalytics: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/webhook/reports/analytics'
			},
			webhookReports: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/webhook/reports'
			},
		};
	}
}

export default new APIS();